import { api } from "@/api"
import type { MaybeRef } from "@vueuse/core"
import { useQuery } from "@tanstack/vue-query"

type GratuitySummaryQuery = {
  start?: string
  end?: string
}

type GratuitySummaryResponse = {
  gratuityReceived: number
  averageGratuityPercentage: number
  fractionOfTransactionsWithGratuity: string
  totalServiceCharge: number
  warnIncorrectCurrencyTransaction: boolean
}

const retrieveGratuitySummary = async (
  query: GratuitySummaryQuery
): Promise<GratuitySummaryResponse> => {
  const { body } = await api.get<GratuitySummaryResponse>(
    "/reports/gratuity/summary/",
    {
      query: query,
    }
  )
  return body
}

export const useGratuitySummary = (
  query: MaybeRef<GratuitySummaryQuery>
) =>
  useQuery(
    [
      BASE_GRATUITY_SUMMARY_REPORT_QUERY_KEY,
      query,
    ] as const,
    ({ queryKey: [_name, query_] }) =>
      retrieveGratuitySummary(unref(query_))
  )
